import { Injectable } from '@angular/core';
import { count, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TabService {

  //public ofertaBase:number = 2;

  public steps:Array<any> = [];
  public stepsConut:number = 0;
  public currentStep:number = 0;

  //animate
  public animate:boolean = false;
  public tabProgress:boolean = false;

  // stepes progress
  stepsSubject = new Subject<any>();
	getSteps(): Observable<any> {
		return this.stepsSubject.asObservable();
	}

  // count status
  stepsConutSubject = new Subject<any>();
	getStepsConut(): Observable<any> {
		return this.stepsConutSubject.asObservable();
	}

  // current push
  currentStepSubject = new Subject<any>();
	getCurrentStep(): Observable<any> {
		return this.currentStepSubject.asObservable();
	}

  // start animate
  animateSubject = new Subject<any>();
	getAnimate(): Observable<any> {
		return this.animateSubject.asObservable();
	}
  // no tabProgress
  tabProgressSubject = new Subject<any>();
	getTabProgress(): Observable<any> {
		return this.tabProgressSubject.asObservable();
	}


  constructor() {
  }

  setStepsConut(count: number): number {    
    this.stepsConut = count;
    this.stepsConutSubject.next(count);
    this.setSteps(this.stepsConut)
    return count;
  }

  setSteps(count:number) {
    this.steps = this.numberToArray(count);
    this.stepsSubject.next(this.steps);
  }


  nextStep() {
    if (this.currentStep < (this.stepsConut)) {
      this.currentStep++;
      this.currentStepSubject.next(this.currentStep);
    }
  }

  currentStepPosition(step:number) {
    this.currentStep = step;
    this.currentStepSubject.next(this.currentStep);
  }

  prevStep() {
    if (this.currentStep > 0) {
      this.currentStep--;
      this.currentStepSubject.next(this.currentStep);
    }
  }

  startAnimate(vuale:boolean) {
    this.animate = vuale;
    this.animateSubject.next(this.animate);
  }

  setTabProgress(vuale:boolean) {
    this.tabProgress = vuale;
    this.tabProgressSubject.next(this.tabProgress);
  }

  numberToArray(count: number): number[] {
    return Array.from({ length: count }, (_, i) => i + 1);
  }

  reset() {
    const count = 0;
    this.currentStep = count;
    this.currentStepSubject.next(this.currentStep);
  }
}
